export default __webpack_public_path__ + "static/media/heroBackground.1c4b6a0b.png";